export default {
  windown_chats: [
    // {
    //   chanel_id: null,
    //   is_open: false,
    //   messageList: [
    //   ],
    //   participants: [
    //     {
    //       id: '1',
    //       name: 'admins',
    //       imageUrl: 'http://192.168.1.101/storage/media/avatar_customs/avatar_48.jpg'
    //     }
    //   ]
    // }
  ]
}



// WEBPACK FOOTER //
// ./src/store/module/chat/state.js